export enum StorageKey {
  PartnerRefCode = 'partnerRefCode',
}
